import { apiUrl } from "../../../config";
import axios from "axios";

const headers = () => ({
  "X-Requested-With": "XMLHttpRequest",
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("auth"),
});

// Tri alphabétique insensible à la casse, comme le fait le serveur.
const parLibelle = (a, b) =>
  String(a.lib || "").localeCompare(String(b.lib || ""), "fr", {
    sensitivity: "base",
  });

export const state = {
  // Bureaux d'études de sol partagés : la liste vit en base et s'enrichit
  // dès qu'une valeur est saisie librement sur un dossier.
  // Entrées `{ id, lib }` : l'id est ce qui permet d'en supprimer une.
  ListeEtudeSol: [],
};

export const mutations = {
  SET_ETUDE_SOL(state, newValue) {
    state.ListeEtudeSol = (newValue || []).slice().sort(parLibelle);
  },
  ADD_ETUDE_SOL(state, entree) {
    // Tolère une chaîne : l'ajout local (valeur saisie sur un dossier) ne
    // connaît pas encore l'id attribué par le serveur.
    const ajout =
      typeof entree === "string" ? { id: null, lib: entree } : entree;

    if (!ajout || !ajout.lib) {
      return;
    }

    const existe = state.ListeEtudeSol.some(
      (v) => String(v.lib).toUpperCase() === String(ajout.lib).toUpperCase()
    );

    if (!existe) {
      state.ListeEtudeSol = [...state.ListeEtudeSol, ajout].sort(parLibelle);
    }
  },
  REMOVE_ETUDE_SOL(state, id) {
    state.ListeEtudeSol = state.ListeEtudeSol.filter((v) => v.id !== id);
  },
};

export const getters = {
  // Libellés seuls : c'est ce que consomment les listes déroulantes et les
  // filtres, qui stockent un texte (`clients.etude_sol`), pas une clé.
  ListeEtudeSol(state) {
    return state.ListeEtudeSol.map((v) => v.lib);
  },
  // Entrées complètes, pour l'écran qui propose d'en supprimer.
  ListeEtudeSolDetail(state) {
    return state.ListeEtudeSol;
  },
};

export const actions = {
  getEtudeSol({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/etude-sol", { headers: headers() })
        .then((response) => {
          commit("SET_ETUDE_SOL", response.data.data);
          resolve(response.data.data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },

  // Ajout explicite depuis la liste déroulante (« Ajouter »).
  creerEtudeSol({ commit }, { lib }) {
    const valeur = String(lib || "").trim();

    return new Promise((resolve, reject) => {
      if (valeur === "") {
        reject(new Error("Libellé vide"));
        return;
      }

      axios
        .post(apiUrl + "api/etude-sol", { lib: valeur }, { headers: headers() })
        .then((response) => {
          // Le serveur renvoie l'entrée créée — ou l'existante s'il en avait
          // déjà une du même nom. On reprend son id pour pouvoir la supprimer
          // sans attendre un rechargement de la liste.
          const creee = response.data.data;
          commit(
            "ADD_ETUDE_SOL",
            creee && creee.id ? { id: creee.id, lib: creee.lib } : valeur
          );
          resolve(valeur);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },

  // Retire un bureau d'études de la liste proposée. Les dossiers qui le
  // portent déjà gardent leur valeur : la colonne stocke un libellé.
  supprimerEtudeSol({ commit }, { id } = {}) {
    return new Promise((resolve, reject) => {
      if (id == null) {
        reject(new Error("Identifiant manquant"));
        return;
      }

      axios
        .delete(apiUrl + "api/etude-sol/" + id, { headers: headers() })
        .then(() => {
          commit("REMOVE_ETUDE_SOL", id);
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },

  // La valeur est déjà mémorisée côté serveur à l'enregistrement du dossier ;
  // cet ajout local évite d'attendre un rechargement pour la voir proposée.
  ajouterEtudeSolLocale({ commit }, { lib }) {
    if (lib && String(lib).trim() !== "") {
      commit("ADD_ETUDE_SOL", String(lib).trim());
    }
  },
};
